export default __webpack_public_path__ + "static/media/logo-update-eid.d69d8be6.png";